import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "qts",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "qts__table" }

import { ref, onMounted, onBeforeUnmount } from "vue";

const ROW_HEIGHT = 50;

export default /*@__PURE__*/_defineComponent({
  __name: 'QTLiteSkeleton',
  props: {
    rows: { default: 12 },
    columns: { default: 5 }
  },
  setup(__props: any) {

const props = __props;

// Набор ширин полос (в %), чередуем по строкам, чтобы скелетон выглядел «живым»,
// а не из одинаковых ячеек. Первая колонка обычно шире (имена), дальше уже.
const widthPatterns: number[][] = [
  [92, 70, 55, 78, 60],
  [55, 70, 48, 40, 50],
  [88, 72, 60, 80, 46],
  [70, 50, 55, 70, 64],
  [40, 45, 40, 55, 58],
  [86, 74, 62, 76, 50],
  [33, 70, 36, 60, 44],
  [82, 72, 58, 78, 62],
  [66, 60, 52, 50, 70],
  [84, 70, 60, 74, 48],
  [50, 44, 38, 64, 56],
];

function cellWidth(rowIndex: number, colIndex: number): string {
  const pattern = widthPatterns[rowIndex % widthPatterns.length];
  const w = pattern[colIndex % pattern.length];
  return `${w}%`;
}

// Высоту строки знаем из стилей (паддинги + высота полосы). По ней считаем, сколько
// строк нужно, чтобы заполнить тело до низа; следим за изменением высоты.
const bodyEl = ref<HTMLElement | null>(null);
const rowCount = ref<number>(props.rows);
let ro: ResizeObserver | null = null;

function recompute() {
  const h = bodyEl.value?.clientHeight || 0;
  const fit = Math.ceil(h / ROW_HEIGHT) + 1;
  const next = Math.max(props.rows, fit);
  if (next !== rowCount.value) rowCount.value = next;
}

onMounted(() => {
  recompute();
  if (bodyEl.value && typeof ResizeObserver !== "undefined") {
    ro = new ResizeObserver(() => recompute());
    ro.observe(bodyEl.value);
  }
});

onBeforeUnmount(() => {
  ro?.disconnect();
  ro = null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"qts__toolbar\" data-v-5f3fa2c8><div class=\"qts__tgroup\" data-v-5f3fa2c8><span class=\"qts__bar qts__bar--tool\" style=\"width:110px;\" data-v-5f3fa2c8></span><span class=\"qts__dot qts__dot--sm qts__dot--first\" data-v-5f3fa2c8></span><span class=\"qts__dot qts__dot--sm\" data-v-5f3fa2c8></span><span class=\"qts__dot qts__dot--sm\" data-v-5f3fa2c8></span><span class=\"qts__bar qts__bar--tool\" style=\"width:150px;\" data-v-5f3fa2c8></span></div><div class=\"qts__tgroup\" data-v-5f3fa2c8><span class=\"qts__bar qts__bar--tool\" style=\"width:120px;\" data-v-5f3fa2c8></span><span class=\"qts__bar qts__bar--tool\" style=\"width:90px;\" data-v-5f3fa2c8></span><span class=\"qts__bar qts__bar--tool\" style=\"width:110px;\" data-v-5f3fa2c8></span></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"qts__row qts__row--head\" data-v-5f3fa2c8><div class=\"qts__cell qts__cell--lead\" data-v-5f3fa2c8><span class=\"qts__dot\" data-v-5f3fa2c8></span></div><span class=\"qts__bar qts__bar--head\" data-v-5f3fa2c8></span></div><div class=\"qts__divider\" data-v-5f3fa2c8></div>", 2)),
      _createElementVNode("div", {
        ref_key: "bodyEl",
        ref: bodyEl,
        class: "qts__body"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowCount.value, (r) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `r${r}`,
            class: "qts__row"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "qts__cell qts__cell--lead" }, [
              _createElementVNode("span", { class: "qts__dot" })
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `r${r}c${c}`,
                class: "qts__cell"
              }, [
                _createElementVNode("span", {
                  class: "qts__bar",
                  style: _normalizeStyle({ width: cellWidth(r - 1, c - 1) })
                }, null, 4)
              ]))
            }), 128))
          ]))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})